// src/components/homepage_content/TopNavBar.js
import React, { useState, useMemo, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';

const TopNavBar = () => {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState('Home');

  const games = useMemo(() => [
    { name: 'Home', link: '/' },
    { name: 'Sports', link: '/sports' },
    { name: 'Live', link: '/live' },
    { name: 'Casino', link: '/casino' },
    { name: 'Slots', link: '/casino' },
    { name: 'Promotions', link: '/promotions' },
    { name: 'Esports', link: '/esports' },
  ], []);

  // Update active link based on current route
  React.useEffect(() => {
    const currentGame = games.find(game => game.link === location.pathname);
    if (currentGame) {
      setActiveLink(currentGame.name);
    }
  }, [location.pathname, games]);

  const handleLinkClick = useCallback((name) => {
    setActiveLink(name);
  }, []);

  const getInitials = useCallback((name) => {
    return name.split(' ').map(word => word[0]).join('').toUpperCase();
  }, []);

  return (
    <header className="sticky top-0 z-30 bg-gray-900 border-b border-gray-700">
      {/* Navigation Menu */}
      <div className="relative">
        <div className="px-4 pb-2 overflow-x-auto scrollbar-hide">
          <nav 
            className="flex items-center space-x-6"
            aria-label="Main navigation"
          >
            {games.map((category) => (
              <Link
                key={category.name}
                to={category.link}
                onClick={() => handleLinkClick(category.name)}
                className={`relative whitespace-nowrap text-sm py-2 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:rounded ${
                  activeLink === category.name
                    ? 'text-blue-400 font-semibold'
                    : 'text-gray-400 hover:text-white'
                }`}
                aria-current={activeLink === category.name ? 'page' : undefined}
              >
                <span className="relative z-10 px-1 py-0.5">
                  {category.name}
                </span>
                {activeLink === category.name && (
                  <span 
                    className="absolute left-0 bottom-0 h-0.5 w-full bg-blue-500 rounded-full"
                    aria-hidden="true"
                  />
                )}
              </Link>
            ))}
          </nav>
        </div>
        
        {/* Gradient overlay for scroll indication */}
        <div 
          className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-gray-900 to-transparent pointer-events-none"
          aria-hidden="true"
        />
      </div>
    </header>
  );
};

export default TopNavBar;